import {navigate} from 'gatsby';
import * as React from 'react';

// https://github.com/gatsbyjs/gatsby/issues/21548#issuecomment-587466309
const Redirect = ({to}: {to: string}) => {
  React.useEffect(() => {
    navigate(to);
  }, []);

  return <></>;
};

export default Redirect;
